module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    staticClass: "cb-discount cb-transition__tab",
    attrs: {
      "id": "cb-discount"
    }
  }, [_c('cb-toggle', {
    attrs: {
      "parent": _vm.$refs.parent
    }
  }, [(!_vm.discountBoxShown) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    key: "action",
    staticClass: "cb-discount__action",
    class: {
      'cb-discount__action--center': _vm.centerAlign
    },
    on: {
      "click": function($event) {
        _vm.showDiscountBox($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.ct('coupon.label')))]) : _c('div', {
    key: "input",
    staticClass: "cb-text",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('label', {
    staticClass: "cb-text__label",
    style: (_vm.themeColor),
    attrs: {
      "for": "coupon-code"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponCode),
      expression: "couponCode"
    }],
    ref: "x1",
    staticClass: "cb-text__control cb-text__control--left",
    class: {
      'cb-text__control--error': _vm.couponErrorMessage && _vm.couponErrorMessage.length > 0
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.ct('coupon.placeholder'),
      "id": "coupon-code"
    },
    domProps: {
      "value": (_vm.couponCode)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.applyCoupon()
      }, function($event) {
        _vm.clearCouponError()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.couponCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.couponCode && _vm.couponCode.length > 0) ? _c('button-field', {
    staticClass: "cb-transition__fade",
    attrs: {
      "custom-class": 'primary icon field',
      "showLoader": _vm.showDiscountButtonLoader,
      "attr": 'coupon_submit'
    },
    on: {
      "next": _vm.applyCoupon
    }
  }, [_c('i', {
    staticClass: "icon-long-arrow-right"
  })]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('cb-slide-n-fade', [(_vm.couponErrorMessage) ? _c('div', {
    staticClass: "cb-text__error",
    class: {
      'cb-text__error--center': _vm.centerAlign
    }
  }, [_vm._v("\n      " + _vm._s(_vm.couponErrorMessage) + "\n    ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c2b1570"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/DiscountComponent.vue
// module id = 339
// module chunks = 24 34 66